import React, {FunctionComponent} from 'react'

const NoResult: FunctionComponent = () => (
  <div className="graph-empty">
    <p>No Results</p>
  </div>
)

export default NoResult
